module.exports = __webpack_public_path__ + "img/avatar4.85120e94.png";